import { render, staticRenderFns } from "./SetAuth.vue?vue&type=template&id=b578bad2&"
import script from "./SetAuth.vue?vue&type=script&lang=js&"
export * from "./SetAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports